// This file contains helper functions for font size functionality
// The main font size logic is now in FontSizeCommand.js

import { $getSelection, $isRangeSelection } from 'lexical';
import { $isFontSizeNode } from './FontSizeNode';

/**
 * Check if the current selection contains any font-sized text
 */
export function hasFontSizeInSelection() {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return false;
  }

  const nodes = selection.getNodes();
  return nodes.some($isFontSizeNode);
}

/**
 * Get all font sizes in the current selection
 */
export function getFontSizesInSelection() {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return [];
  }

  const nodes = selection.getNodes();
  const fontSizeNodes = nodes.filter($isFontSizeNode);
  return fontSizeNodes.map((node) => node.getFontSize());
}

/**
 * Check if the current selection has a specific font size
 */
export function hasSpecificFontSizeInSelection(fontSize) {
  const fontSizes = getFontSizesInSelection();
  return fontSizes.includes(fontSize);
}

/**
 * Get the most common font size in the current selection
 */
export function getMostCommonFontSizeInSelection() {
  const fontSizes = getFontSizesInSelection();
  if (fontSizes.length === 0) {
    return null;
  }

  // Count occurrences of each font size
  const counts = {};
  fontSizes.forEach((size) => {
    counts[size] = (counts[size] || 0) + 1;
  });

  // Find the most common one
  return Object.keys(counts).reduce((a, b) => (counts[a] > counts[b] ? a : b));
}
